// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"087eca7891e07f907204","678":"32e7f723b1b81671005b","883":"c585d2ace877b203e640"}[chunkId] + ".js";
};